import type { QuizPublic } from '@repo/types/quiz';

import { UserLvl } from '@repo/types/enums/userLvl';
import { ArrowLeftIcon } from 'lucide-react';
import { useMemo } from 'react';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';
import { useBackTo } from '@/hooks/quiz';
import { useCredentials } from '@/store/auth-store';

interface QuizHeaderProps {
  quiz: QuizPublic;
}

export default function QuizHeader(quizHeaderProps: QuizHeaderProps) {
  const { quiz } = quizHeaderProps;
  const { lvl } = useCredentials();
  const { backTo } = useBackTo();

  const urlTo = useMemo<string>(() => {
    if (backTo) {
      return backTo;
    }
    if (lvl === UserLvl.ADMIN || lvl === UserLvl.TEACHER) {
      return `/manage/quizzes/${quiz.id}`;
    }
    return `/quizzes/${quiz.id}`;
  }, [backTo, lvl, quiz.id]);

  return (
    <div className="bg-background relative flex w-full flex-col gap-4 rounded-2xl border p-4">
      <Button variant="outline" asChild size="sm" className="absolute top-4 left-4 w-fit md:relative md:top-0 md:left-0">
        <Link to={urlTo}>
          <ArrowLeftIcon />
        </Link>
      </Button>
      <div className="space-y-1">
        <h1 className="mx-10.5 text-center text-xl font-bold md:ms-0 md:text-start">{quiz.name}</h1>
        <p className="text-text-tertiary text-center text-sm md:text-start">{quiz.desc ?? 'Brak opisu'}</p>
      </div>
    </div>
  );
}
